export const SET_STATISTIC_PAGE = "@STATISTIC_PAGES/SET_STATISTIC_PAGE";
export const SET_ALL_STATISTIC_PAGES = "@STATISTIC_PAGES/SET_ALL_STATISTIC_PAGES";
export const SET_PAGES_SETTINGS = "@STATISTIC_PAGES/SET_PAGES_SETTINGS";
